export const common = {
  nav: {
    home: 'Acasă',
    about: 'Despre noi',
    services: 'Servicii',
    doctors: 'Medici',
    contact: 'Contacte',
    appointment: 'Programare'
  },
  hero: {
    title: 'Zâmbetul sănătos începe aici',
    subtitle: 'Clinică stomatologică modernă cu specialiști experimentați și echipamente avansate pentru confortul și sănătatea dumneavoastră',
    cta: 'Programare',
    ctaSecondary: 'Serviciile noastre'
  },
  stats: {
    experience: '20+',
    experienceLabel: 'Ani de experiență',
    patients: '5000+',
    patientsLabel: 'Pacienți mulțumiți',
    specialists: '4',
    specialistsLabel: 'Specialiști calificați'
  },
  about: {
    title: 'Despre clinica noastră',
    description: 'Zimbet32 este o clinică stomatologică modernă care oferă o gamă completă de servicii dentare. Folosim tehnologii și materiale avansate pentru a asigura cele mai bune rezultate pentru pacienții noștri.',
    foundedYear: 'Anul înființării',
    yearsExperience: 'Ani de experiență',
    feature1Title: 'Specialiști experimentați',
    feature1Desc: 'Medici cu certificate internaționale și ani de experiență',
    feature2Title: 'Echipament modern',
    feature2Desc: 'Cele mai noi tehnologii și materiale pentru tratament de calitate',
    feature3Title: 'Abordare individuală',
    feature3Desc: 'Plan de tratament personalizat pentru fiecare pacient',
    feature4Title: 'Tratament fără durere',
    feature4Desc: 'Atmosferă confortabilă și anestezie modernă',
    ctaButton: 'Programare'
  },
  services: {
    title: 'Serviciile noastre',
    subtitle: 'Gamă completă de servicii stomatologice pentru întreaga familie',
    therapeutic: 'Stomatologie terapeutică',
    therapeuticDesc: 'Tratamentul cariilor, pulpitei, periodontitei folosind materiale și tehnologii moderne',
    orthopedic: 'Stomatologie ortopedică',
    orthopedicDesc: 'Protezare dentară, instalare de coroane, fațete și construcții de punte',
    surgery: 'Stomatologie chirurgicală',
    surgeryDesc: 'Extracția dinților de orice complexitate, pregătire pentru implantare',
    implantation: 'Implantare dentară',
    implantationDesc: 'Instalarea implanturilor dentare folosind tehnologii avansate',
    orthodontics: 'Ortodonție',
    orthodonticsDesc: 'Corectarea mușcăturii, instalarea sistemelor de bretele și aliniatori',
    prevention: 'Prevenție și igienă',
    preventionDesc: 'Curățare profesională a dinților, fluorurare, sigilare de fisuri',
    bookButton: 'Programare'
  },
  servicePages: {
    breadcrumb: {
      home: 'Acasă',
      services: 'Servicii'
    },
    gallery: 'Galeria lucrărilor',
    whyUs: 'De ce să ne alegeți',
    procedures: 'Proceduri',
    bookAppointment: 'Programare',
    therapeutic: {
      title: 'Stomatologie terapeutică',
      description: 'Stomatologia terapeutică este baza sănătății dinților dumneavoastră. Specialiștii noștri folosesc tehnici și materiale moderne pentru tratarea cariilor, pulpitei, periodontitei și altor boli. Folosim echipamente microscopice pentru diagnostic precis și tratament de calitate al canalelor radiculare.',
      procedure1: 'Tratamentul cariilor',
      procedure1Desc: 'Îndepărtarea țesuturilor afectate și restaurarea cu materiale compozite',
      procedure2: 'Tratamentul pulpitei',
      procedure2Desc: 'Tratament endodontic folosind microscop',
      procedure3: 'Tratamentul periodontitei',
      procedure3Desc: 'Tratament complex al inflamației țesuturilor din jurul rădăcinii dintelui',
      procedure4: 'Restaurarea dinților',
      procedure4Desc: 'Restaurarea formei și funcției dintelui cu materiale moderne',
      procedure5: 'Tratament sub microscop',
      procedure5Desc: 'Tratament de înaltă precizie cu mărire multiplă',
      procedure6: 'Retratarea canalelor',
      procedure6Desc: 'Tratament endodontic repetat când este necesar',
      benefit1: 'Tratament fără durere',
      benefit1Desc: 'Anestezie modernă și atmosferă confortabilă',
      benefit2: 'Materiale de calitate',
      benefit2Desc: 'Folosim doar compozite premium verificate',
      benefit3: 'Garanția rezultatului',
      benefit3Desc: 'Oferim garanție pentru toate tipurile de tratament'
    },
    orthopedic: {
      title: 'Stomatologie ortopedică',
      description: 'Stomatologia ortopedică se ocupă cu restaurarea dinților pierduți și a funcțiilor lor. Oferim toate tipurile de protezare: de la coroane individuale la proteze complete detașabile. Folosim materiale moderne — ceramică, dioxid de zirconiu, metal-ceramică — pentru crearea de structuri estetice și durabile.',
      procedure1: 'Coroane ceramice',
      procedure1Desc: 'Coroane estetice din ceramică presată',
      procedure2: 'Coroane din dioxid de zirconiu',
      procedure2Desc: 'Structuri rezistente și biocompatibile',
      procedure3: 'Fațete ceramice',
      procedure3Desc: 'Suprapuneri subțiri pentru un zâmbet perfect',
      procedure4: 'Proteze de punte',
      procedure4Desc: 'Restaurarea mai multor dinți lipsă',
      procedure5: 'Protezare detașabilă',
      procedure5Desc: 'Proteze detașabile parțiale și complete',
      procedure6: 'Protezare pe implanturi',
      procedure6Desc: 'Structuri fixe pe implanturi',
      benefit1: 'Abordare individuală',
      benefit1Desc: 'Fiecare structură este realizată conform amprentelor individuale',
      benefit2: 'Laborator dentar propriu',
      benefit2Desc: 'Control al calității în toate etapele de fabricație',
      benefit3: 'Estetică naturală',
      benefit3Desc: 'Protezele sunt indistincte de dinții naturali'
    },
    surgery: {
      title: 'Stomatologie chirurgicală',
      description: 'Stomatologia chirurgicală include o gamă largă de operații — de la extracția simplă a dinților până la intervenții complexe de plastie osoasă. Chirurgii noștri au o experiență vastă în efectuarea operațiilor de orice complexitate. Folosim echipamente și tehnici moderne pentru a minimiza traumatismul și a accelera vindecarea.',
      procedure1: 'Extracția dinților',
      procedure1Desc: 'Extracție atraumatică a dinților de orice complexitate',
      procedure2: 'Extracția măselelor de minte',
      procedure2Desc: 'Îndepărtarea sigură a dinților incluși și distopici',
      procedure3: 'Rezecția vârfului rădăcinii',
      procedure3Desc: 'Conservarea dintelui în caz de inflamație în zona rădăcinii',
      procedure4: 'Plastie osoasă',
      procedure4Desc: 'Augmentarea țesutului osos pentru implantare',
      procedure5: 'Sinus-lifting',
      procedure5Desc: 'Creșterea volumului osos în maxilarul superior',
      procedure6: 'Plastia gingivală',
      procedure6Desc: 'Corectarea nivelului și conturului gingiei',
      benefit1: 'Chirurgi experimentați',
      benefit1Desc: 'Specialiști cu ani de experiență în operații complexe',
      benefit2: 'Echipament modern',
      benefit2Desc: 'Piezochirurgie și alte tehnologii inovatoare',
      benefit3: 'Vindecare rapidă',
      benefit3Desc: 'Traumatism minim și perioadă scurtă de reabilitare'
    },
    implantation: {
      title: 'Implantare Dentară',
      description: 'Implantarea dentară este o metodă modernă și fiabilă de restaurare a dinților lipsă. Folosim implanturi de calitate de la producători de top și tehnologii avansate pentru a obține rezultate durabile. Specialiștii noștri au experiență vastă în efectuarea implantării de orice complexitate.',
      procedures: {
        single: {
          title: 'Implant Singular',
          description: 'Plasarea unui implant pentru înlocuirea unui dinte lipsă'
        },
        multiple: {
          title: 'Implanturi Multiple',
          description: 'Restaurarea mai multor dinți folosind implanturi'
        },
        allOn4: {
          title: 'All-on-4',
          description: 'Proteză completă pe 4 implanturi'
        },
        bonePlasty: {
          title: 'Grefă Osoasă',
          description: 'Augmentarea țesutului osos pentru plasarea implantului'
        },
        sinusLift: {
          title: 'Sinus Lift',
          description: 'Creșterea volumului osos în zona maxilarului superior'
        },
        immediate: {
          title: 'Implantare Imediată',
          description: 'Plasarea implantului imediat după extracția dintelui'
        }
      },
      benefits: {
        permanent: {
          title: 'Durabilitate',
          description: 'Implanturile durează decenii cu îngrijire adecvată'
        },
        natural: {
          title: 'Aspect Natural',
          description: 'Implanturile arată și funcționează ca dinții naturali'
        },
        boneSaving: {
          title: 'Conservarea Osului',
          description: 'Prevenirea atrofiei osoase a maxilarului'
        }
      },
      gallery: {
        surgery: 'Procedura de implantare',
        crown: 'Plasarea coroanei pe implant',
        allOn4: 'Proteză All-on-4',
        xray: 'Radiografie implant',
        boneGraft: 'Grefă osoasă',
        result: 'Rezultat implantare'
      }
    },
    orthodontics: {
      title: 'Ortodonție',
      description: 'Tratamentul ortodontic ajută la corectarea mușcăturii și alinierea dinților, creând un zâmbet frumos și sănătos. Oferim diverse sisteme de corecție — de la aparate dentare clasice la alignere moderne. Ortodonții noștri vor dezvolta un plan de tratament individual pentru a obține cele mai bune rezultate.',
      procedures: {
        braces: {
          title: 'Aparate Metalice',
          description: 'Sistem clasic și eficient de corecție a mușcăturii'
        },
        invisalign: {
          title: 'Invisalign',
          description: 'Alignere transparente detașabile pentru tratament discret'
        },
        lingual: {
          title: 'Aparate Linguale',
          description: 'Aparate instalate pe partea interioară a dinților'
        },
        children: {
          title: 'Ortodonție Pediatrică',
          description: 'Corectarea mușcăturii la copii și adolescenți'
        },
        retainers: {
          title: 'Retenție',
          description: 'Menținerea rezultatelor după îndepărtarea aparatului'
        },
        consultation: {
          title: 'Consultație Ortodontică',
          description: 'Diagnostic și elaborarea planului de tratament'
        }
      },
      benefits: {
        beautiful: {
          title: 'Zâmbet Frumos',
          description: 'Dinții drepți și mușcătura corectă îmbunătățesc aspectul'
        },
        health: {
          title: 'Sănătate Dentară',
          description: 'Mușcătura corectă reduce riscul de boli'
        },
        confidence: {
          title: 'Încredere',
          description: 'Zâmbetul frumos crește stima de sine'
        }
      },
      gallery: {
        braces: 'Aparate metalice',
        invisalign: 'Alignere Invisalign',
        beforeAfter: 'Înainte și după tratament',
        examination: 'Examinare ortodontică',
        ceramic: 'Aparate ceramice',
        result: 'Rezultat tratament'
      }
    },
    prevention: {
      title: 'Prevenție și Igienă',
      description: 'Prevenția este fundamentul sănătății dinților și gingiilor. Igiena profesională regulată a cavității bucale ajută la prevenirea cariilor, bolilor gingivale și altor probleme. Recomandăm controale preventive și curățare dentară la fiecare 6 luni.',
      procedures: {
        cleaning: {
          title: 'Curățare Profesională',
          description: 'Îndepărtarea plăcii și tartrului cu ultrasunete'
        },
        whitening: {
          title: 'Albire Dentară',
          description: 'Albire profesională pentru un zâmbet strălucitor'
        },
        fluoride: {
          title: 'Fluorurare',
          description: 'Întărirea smalțului cu preparate cu fluor'
        },
        checkup: {
          title: 'Control Preventiv',
          description: 'Diagnostic regulat al stării dinților și gingiilor'
        },
        sealants: {
          title: 'Sigilare Fisuri',
          description: 'Protecția suprafețelor de mestecat împotriva cariilor'
        },
        education: {
          title: 'Educație Igienică',
          description: 'Consultație privind îngrijirea corectă a dinților'
        }
      },
      benefits: {
        savings: {
          title: 'Economii',
          description: 'Prevenția este mai ieftină decât tratarea bolilor avansate'
        },
        health: {
          title: 'Sănătate',
          description: 'Prevenirea dezvoltării problemelor grave'
        },
        early: {
          title: 'Detectare Timpurie',
          description: 'Identificarea problemelor într-un stadiu incipient'
        }
      },
      gallery: {
        cleaning: 'Curățare profesională',
        whitening: 'Albire dentară',
        fluoride: 'Fluorurare',
        checkup: 'Control preventiv',
        sealant: 'Sigilare fisuri',
        result: 'Dinți sănătoși'
      }
    }
  },
  doctors: {
    title: 'Specialiștii noștri',
    subtitle: 'Echipă de profesioniști cu ani de experiență',
    experience: 'Experiență',
    years: 'ani'
  },
  contact: {
    title: 'Contactați-ne',
    subtitle: 'Programați o consultație sau puneți o întrebare',
    form: {
      name: 'Numele dumneavoastră',
      phone: 'Telefon',
      email: 'Email',
      message: 'Mesaj',
      submit: 'Trimite cererea',
      success: 'Mulțumim! Vă vom contacta în curând.',
      error: 'A apărut o eroare. Vă rugăm să încercați mai târziu.'
    },
    info: {
      address: 'Adresă',
      addressValue: 'MD-2012, mun. Chișinău, str. București, 60',
      phone: 'Telefon',
      phoneValue: '+373 22 123 456',
      email: 'Email',
      emailValue: 'info@zimbet32.md',
      hours: 'Program de lucru',
      hoursValue: 'Lun-Vin: 9:00 - 19:00'
    }
  },
  footer: {
    description: 'Clinică stomatologică modernă cu specialiști experimentați',
    quickLinks: 'Link-uri rapide',
    contactInfo: 'Informații de contact',
    copyright: 'Zimbet32. Toate drepturile rezervate.'
  }
};